/* eslint-disable react/jsx-props-no-spreading */
import { GridCellProps } from '@progress/kendo-react-grid';
import * as React from 'react';
import { GridCellTypes } from '../../core/enums';
import { formatcurrency, formatDate } from '../../lib/utils';
import ColumnInterface from '../../models/ColumnInterface';
import { FullNameAndEmailCellContent } from './FullNameAndEmailCell';
import { FullNameCellContent } from './FullNameCell';
import { StyledLink } from './LinkCell';
import { getFamilyMemberName } from './FamilyMemberCell';
import { DropDownListOption } from '../../models/DropDownListOption';
import MobileSummaryCellItem from './MobileSummaryCellItem';
import useClientContextStore from '../../zustandStore/clientContextStore';

const MobileSummaryCell =
	(columns: ColumnInterface[], onClick?: (item: unknown) => void) => (cellProps: GridCellProps) => {
		const clientWithOwnerDetails = useClientContextStore((state) => state.clientWithOwnerDetails);
		return (
			<td>
				{onClick ? (
					<StyledLink onClick={() => onClick(cellProps.dataItem)}>
						{createCellContent(columns, cellProps, clientWithOwnerDetails)}
					</StyledLink>
				) : (
					createCellContent(columns, cellProps, clientWithOwnerDetails)
				)}
			</td>
		);
	};

export default MobileSummaryCell;

const createCellContent = (
	columns: ColumnInterface[],
	cellProps: GridCellProps,
	clientWithOwnerDetails: DropDownListOption<number>[]
) =>
	columns.map((c) => {
		if (c.cellType === GridCellTypes.FullNameAndEmail)
			return <FullNameAndEmailCellContent key={c.field} {...cellProps} title={c.title} />;
		if (c.cellType === GridCellTypes.FullName)
			return <FullNameCellContent key={c.field} {...cellProps} title={c.title} />;

		let value = cellProps.dataItem[c.field];
		switch (c.cellType) {
			case GridCellTypes.Date:
				value = formatDate(value);
				break;
			case GridCellTypes.Money:
				value = value ? `${formatcurrency(value)}` : null;
				break;
			case GridCellTypes.YesOrNo:
				value = value ? 'Yes' : 'No';
				break;
			case GridCellTypes.SemicolonDelimited:
				value = value ? (value as string).replaceAll(';', ', ') : null;
				break;
			case GridCellTypes.Percentage:
				value = value ? `${value}%` : null;
				break;
			case GridCellTypes.FamilyMember:
				value = getFamilyMemberName(value, clientWithOwnerDetails);
				break;
			default:
				break;
		}

		return <MobileSummaryCellItem key={c.field} title={c.title} value={value} />;
	});
